import styled from 'styled-components';
import { applyStyleModifiers } from 'styled-components-modifiers';

import { rem, themed } from '@/shared/ui/core';

const modifiers = {
  small: () => ({
    styles: `
      width: ${rem(50)};
      height: ${rem(50)};
      `,
  }),
  large: () => ({
    styles: `
        width: ${rem(80)};
        height: ${rem(80)};
      `,
  }),
  xLarge: () => ({
    styles: `
        width: ${rem(120)};
        height: ${rem(120)};
      `,
  }),
};

export const RoundedIconStyled = styled.div.attrs({
  className: 'component__roundedIcon',
})`
  width: ${rem(120)};
  height: ${rem(120)};
  line-height: 1;
  background-color: #F5F6F6;
  border-radius: 100%;
  display: block;
  overflow: hidden;
  position: relative;
  ${applyStyleModifiers(modifiers)}

  svg {
    display: block;
    fill: ${themed('primary.darkGray')};
    max-width: 50%;
    height: auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

`;
